import { MotifAlertIcErrorOutline24px } from "@ey-xd/motif-icon";
import "./ErrorMessage.scss";
import { MotifButton, MotifIcon } from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CANCEL_BUTTON_VARIANT, SAVE_BUTTON_VARIANT } from "@/components/Images/CommonImages";

function ErrorMessage({ errorMessage ,importJobId,caseId,onClose}: { errorMessage?: string ,importJobId?:string |null,caseId?:any,onClose?:any}) {
  const {t}=useTranslation();
  const nav=useNavigate()
  return (
    <div className="error-message">
      <div className="icon-container">
        <MotifIcon
          iconFunction={MotifAlertIcErrorOutline24px}
          stroke="#FF3D00"
          strokeWidth="1"
          size="28"
        />
      </div>
      <div className="message-title">
      {t("pages.claims.claimsTable.bulkImport.uploadFailed")}    

      </div>
      <div className="message-description">
      {errorMessage || t("pages.claims.claimsTable.bulkImport.uploadFailedDescriptionAlt")}
      </div>
      {importJobId && <div className="motif-row justify-self-end align-self-end mar-t-40 ">
        {onClose && <MotifButton onClick={()=>{
          if(onClose){
            onClose()          }
         }} variant={CANCEL_BUTTON_VARIANT} type="button">{t("global.globalActions.cancel")}</MotifButton>}&nbsp;&nbsp;&nbsp;&nbsp;
        <MotifButton onClick={()=>{
          if(importJobId){
            nav(`/case/${caseId}/import/${importJobId}`)
          }
         }} variant={SAVE_BUTTON_VARIANT} type="button">{t("pages.claims.claimsTable.bulkImport.viewImportSummary")}</MotifButton>
    
      </div>}
    </div>
  );
}

export default ErrorMessage;
